// extracted by mini-css-extract-plugin
export var blue = "_3z-g";
export var brand = "_3z-c";
export var darkGrey = "_3z-f";
export var disabled = "_3z-6";
export var disabledSubtle = "_3z-7";
export var error = "_3z-8";
export var green = "_3z-h";
export var grey = "_3z-e";
export var icon = "_3z-0";
export var inherit = "_3z-b";
export var lightGrey = "_3z-d";
export var orange = "_3z-j";
export var pink = "_3z-l";
export var primary = "_3z-1";
export var purple = "_3z-m";
export var quaternary = "_3z-4";
export var quinary = "_3z-5";
export var red = "_3z-k";
export var secondary = "_3z-2";
export var success = "_3z-a";
export var tertiary = "_3z-3";
export var warning = "_3z-9";
export var white = "_3z-n";
export var yellow = "_3z-i";